export enum ErrorEnum {
  None = "Invalid Token.",
  NoState = "No state",
}
